var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotorhome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 99C26.3825 99 21 93.6175 21 87C21 80.3825 26.3825 75 33 75C39.6175 75 45 80.3825 45 87C45 93.6175 39.6175 99 33 99ZM33 81C29.6925 81 27 83.6925 27 87C27 90.3075 29.6925 93 33 93C36.3075 93 39 90.3075 39 87C39 83.6925 36.3075 81 33 81Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87 99C80.3825 99 75 93.6175 75 87C75 80.3825 80.3825 75 87 75C93.6175 75 99 80.3825 99 87C99 93.6175 93.6175 99 87 99ZM87 81C83.6925 81 81 83.6925 81 87C81 90.3075 83.6925 93 87 93C90.3075 93 93 90.3075 93 87C93 83.6925 90.3075 81 87 81Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.183 90H96V84H101.183C101.735 84 102.183 83.5525 102.183 83V67C102.183 66.64 102 66.4025 101.89 66.2925C101.78 66.1825 101.543 66 101.183 66H91.205L81.425 43.1825L86.94 40.82L95.16 60.0025H101.183C103.053 60.0025 104.81 60.73 106.132 62.0525C107.455 63.375 108.183 65.1325 108.183 67.0025V83.0025C108.183 86.8625 105.043 90.0025 101.183 90.0025V90Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8925 64.1825L67.0875 45.97C66.4225 44.42 66.58 42.655 67.51 41.2475C68.4375 39.84 69.9975 39 71.685 39H98.7125C99.1975 39 99.4525 38.7025 99.5625 38.525C99.645 38.3925 99.75 38.155 99.7075 37.8625L96.3975 34.495C95.4625 33.545 94.165 33 92.8325 33H19C18.4475 33 18 33.4475 18 34V39H54.1825V45H12V34C12 30.14 15.14 27 19 27H92.83C95.76 27 98.62 28.1975 100.675 30.29L104.762 34.4475L104.975 34.87C106.067 37.055 105.953 39.6025 104.668 41.68C103.382 43.76 101.158 45 98.7125 45H73.2025L80.41 61.8175L74.895 64.18L74.8925 64.1825Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.183 69H96.1825V75H105.183V69Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90H19C15.14 90 12 86.86 12 83V48H18V83C18 83.5525 18.4475 84 19 84H24V90Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90V59C48 56.2425 50.0925 54 52.6675 54H64.335C66.9075 54 69.0025 56.2425 69.0025 59V90H48ZM54 84H63V60H54V84Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 84H42V90H78V84Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69C28.0375 69 24 64.9625 24 60C24 55.0375 28.0375 51 33 51C37.9625 51 42 55.0375 42 60C42 64.9625 37.9625 69 33 69ZM33 57C31.345 57 30 58.345 30 60C30 61.655 31.345 63 33 63C34.655 63 36 61.655 36 60C36 58.345 34.655 57 33 57Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorhome);
export default __webpack_public_path__ + "static/media/Motorhome.c56d3cc8.svg";
export { ForwardRef as ReactComponent };